import Status from 'clarks/components/ivu-table/status'

let forms = {
   // addUserTrash: {
   //    icon: 'fa fa-university',
   //    title: 'Add User Trash',
   //    subtitle: 'Provide User Trash Details',
   //    forms: [
   //       { type: "text", form_type: "text", class: "col-12 col-md-6", validation: "required|min:3|max:200", model: "service", label: "Service", },
   //       { type: "text", form_type: "text", class: "col-12 col-md-6", validation: "required|min:3|max:200", model: "db_collection", label: "Db Collection", },
   //       { type: "text", form_type: "text", class: "col-12 col-md-6", validation: "required|min:3|max:200", model: "created_at", label: "Created At", },
   //       { type: "text", form_type: "text", class: "col-12 col-md-6", validation: "required|min:3|max:200", model: "action", label: "Action", },
   //       { type: "text", form_type: "text", class: "col-12 col-md-6", validation: "required|min:3|max:200", model: "checksum", label: "Checksum", },

   //    ]
   // },
}

let tables = {
   user_trash: {
      props: {
         icon: 'fa fa-trash-alt',
         title: 'User Trash',
         border: true,
         'max-height': 500,
         'show-summary': false,
         search_fields: ['service', 'db_collection', 'created_at' ],
         columns: [
            { type: 'selection', width: 60, align: 'center' },
            { type: 'index', width: 60, align: 'center' },
            { title: "Service", key: "service", },
            { title: "Db Collection", key: "db_collection", },
            { title: "Deleted At", slot: "created_at", },

            {
               title: "Status",
               key: "status",
               align: 'center',
               width: 180,
               render: (h, params) => {
                  return h(Status, {
                     props: {
                        status: params.row.status
                     }
                  });
               },
               filters: [{
                     label: "Created",
                     value: 1
                  },
                  {
                     label: "Updated",
                     value: 2
                  },
                  {
                     label: "Pending Create Verification",
                     value: 3
                  },
                  {
                     label: "Pending Update Verification",
                     value: 4
                  },
                  {
                     label: "Pending Delete Verification",
                     value: 5
                  }
               ],
               filterMultiple: true,
               filterMethod(value, row) {
                  switch (value) {
                     case 1:
                        return row.status === 'created';
                     case 2:
                        return row.status === 'updated';
                     case 3:
                        return row.status === 'create_pending';
                     case 4:
                        return row.status === 'update_pending';
                     case 5:
                        return row.status === 'delete_pending';
                  }
               }
            },
         ],
         actions: [
            { type: 'menu', title: 'View', event: 'view', allow_multiple: false },
            { type: 'menu', title: 'Restore Record', event: 'user_trash:restore', icon: 'fa-recycle', allow_multiple: true },
         ]
      },
   },
}

export default {
   forms: utils.generateAllFormData(forms),
   tables
}